"use client"

import { extractProperty, replaceRichTextLinks } from "utils"

import styled from "@emotion/styled"
import { Button, Typography } from "@mui/material"
import { useTranslations } from "next-intl"
import { useInView } from "react-intersection-observer"
import { Mobile } from "ui"
import { useInViewConfig } from "ui/transitions/utils"
import CopyButton from "./CopyButton"

const OuterLayout = styled.div``
const StyledLayout = styled.div<{ $inView: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding-top: 32px;
  padding-bottom: 24px;

  ${(p) => p.theme.breakpoints.up("md")} {
    max-width: 700px;
    padding-top: 48px;
    padding-bottom: 48px;
  }
  p {
    margin-bottom: 0px;
  }
`

const StyledScrollButton = styled(Button)`
  background-color: #008761;
`

const StyledWrapperDiv = styled.div`
  ${(p) => p.theme.breakpoints.down("md")} {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }
`

const StyledTypography = styled(Typography)<{ component?: string }>`
  table {
    max-width: 100%;
    overflow-x: auto;
    display: flex;
  }
  a {
    /* word-break: break-all; */
  }
  h2 {
    margin: 0;
  }
`

export default function DynamicTitleRichText({
  data,
  scrollToForm,
}: {
  data: any
  scrollToForm: any
}) {
  const title = extractProperty(data, "title") || data?.jobTitle
  const content = extractProperty(data, "content")
  const { ref, inView } = useInView({ ...useInViewConfig, threshold: 0 })
  const tInner = useTranslations("InnerPages")
  const link = typeof window !== "undefined" ? window.location.href : ""

  return (
    <OuterLayout ref={ref}>
      <StyledLayout $inView={inView}>
        <Typography variant="h2">{title}</Typography>
        <StyledWrapperDiv>
          <Mobile>
            <StyledScrollButton variant="contained" onClick={scrollToForm}>
              {tInner("leaveDetails")}
            </StyledScrollButton>
          </Mobile>
          <CopyButton link={link} />
        </StyledWrapperDiv>
        <StyledTypography
          variant="body1"
          component={"div"}
          dangerouslySetInnerHTML={{
            __html: replaceRichTextLinks(content),
          }}
        />
      </StyledLayout>
    </OuterLayout>
  )
}
